import { go, html, map, strMap } from 'fxjs/es';
import {
  design_collection_page_mo_main,
  design_collection_page_mobile_j_product_detail,
  design_collection_page_pc_j_product_detail,
  design_collection_page_pc_main,
} from '../../../DesignCollection/Detail/S/tmpl.js';
import { OMPReviewTmplS } from '../../../OMP/Review/S/Tmpl/module/OMPReviewTmplS.js';
import { ProductDetailTabsTmplS } from '../Tmpl/module/ProductDetailTabsTmplS.js';
import { OMPCoreAtomTmplS } from '../../../OMP/Core/Atom/S/Tmpl/module/OMPCoreAtomTmplS.js';
import { OMPCoreCellTmplS } from '../../../OMP/Core/Cell/S/Tmpl/module/OMPCoreCellTmplS.js';
import { PriceS } from '../../../Price/S/Function/module/PriceS.js';
import { UtilImageS } from '../../../Util/Image/S/Function/module/UtilImageS.js';
import { OMPProductListS } from '../../../OMP/ProductList/S/Function/module/OMPProductListS.js';
import { getPriceRanges } from '../../../OMP/ProductList/B/Function/productlist.js';
import { ProductDetailTabsS } from '../Function/module/ProductDetailTabsS.js';
import { DC_BANNER_EVENT, DC_BANNER_PRODUCT } from '../../../DesignCollection/Detail/S/constant.js';
import {
  makeExpandableContainer,
  makeProductDetailDeliveryAreaKrHtml,
  makeProductDetailGuidAreaKrHtml,
  makeThumbnailsContainer,
  makeVideoContainer,
} from '../../../Product/Detail/S/tmpl.js';
import { Icon } from '../../../../services/Marpple/client/shared/ui/atoms/Icon/Icon.ts';
import { UtilS } from '../../../Util/S/Function/module/UtilS.js';
import { makeTgHead } from '@modules/ProductDetailTabs/S/Tmpl/BpInfo.js';

export const STORY_TAB = {
  name: 'STORY_TAB',
  title: () => T('product_detail::Story'),
  template: ({ design_collection, is_mobile, product_type, alt, thumbnails = [], video_content = null }) => {
    const [full_design_collection_content, temp_extracted_design_collection] =
      ProductDetailTabsS.extractFirstPatternWithFullImg(design_collection);
    const [story_design_collection, relation_design_collection_content] =
      ProductDetailTabsS.extractRelationDesignCollectionContent(temp_extracted_design_collection);

    return story_design_collection?.id && story_design_collection?.is_hidden === false
      ? is_mobile
        ? html`
            ${makeBannerBody(true, alt, product_type, 'header')}
            ${UtilS.htmlIf(video_content, makeVideoContainer(video_content))}
            ${design_collection_page_mo_main(full_design_collection_content, '')}
            ${makeThumbnailsContainer(thumbnails, is_mobile)}
            ${makeExpandableContainer({
              size: 'md',
              title: T('product_detail::Story'),
              body: html` <div class="body design_collection_body mp_today_detail_mobile_style">
                ${design_collection_page_mobile_j_product_detail(story_design_collection, alt, product_type)}
              </div>`,
            })}
            ${makeBannerBody(true, alt, product_type, 'footer')}
            ${makeRelationBody({
              design_collection_content: relation_design_collection_content,
              is_mobile,
            })}
          `
        : html`
            ${makeBannerBody(false, alt, product_type, 'header')}
            ${UtilS.htmlIf(video_content, makeVideoContainer(video_content))}
            ${design_collection_page_pc_main(full_design_collection_content, '')}
            ${makeThumbnailsContainer(thumbnails, is_mobile)}
            ${makeExpandableContainer({
              size: 'lg',
              title: T('product_detail::Story'),
              body: html`<div class="body design_collection_body mp_today_detail_pc_style">
                ${design_collection_page_pc_j_product_detail(story_design_collection, alt, product_type)}
              </div>`,
            })}
            ${makeRelationBody({
              design_collection_content: relation_design_collection_content,
              is_mobile,
            })}
          `
      : `${UtilS.htmlIf(video_content, makeVideoContainer(video_content))}
            ${makeThumbnailsContainer(thumbnails, is_mobile)}`;
  },
  product_type: (base_product) =>
    Object.keys(base_product?._?.biz_product).length
      ? 'biz'
      : base_product?._?.cate_item?.is_cloth
        ? 'cloth'
        : 'etc',
};

export const REVIEW_TAB = {
  name: 'REVIEW_TAB',
  title: (count) =>
    G.collabo_type === ''
      ? html`<span class="tabs_list_item-review"
            >${new Icon({ name: 'star_fill', size: 16, mo_size: 12, theme: 'primary' }).toHtml()}
            ${T('product_detail::Reviews')}</span
          >
          ${(count > 999 ? '999+' : count) || 0}`
      : '☆ ' + T('product_detail::Reviews') + `(${(count > 999 ? '999+' : count) || 0})`,
  template: ({ reviews, review_total, query, is_mobile }) => html`
    <div class="tab_wrapper">
      ${G.collabo_type == ''
        ? OMPReviewTmplS.reviewTmpl({
            is_mobile,
            reviews,
            review_total,
            cate_lists: [],
            query,
            is_detail_page: true,
          })
        : ProductDetailTabsTmplS.makeReviewsHtml({ reviews, review_total, query })}
    </div>
  `,
};

export const BP_DETAIL_TAB = {
  name: 'BP_DETAIL_TAB',
  title: () => T('product_detail::Product Info'),
  template: ({
    size_info_url,
    id,
    cate_list_id,
    cate_item_id,
    size_compare,
    brand_logo,
    brand_name,
    brand_description,
    product_info,
    guide,
    size_table,
    is_mobile,
  }) => html`
    <div class="tab_wrapper">
      ${ProductDetailTabsTmplS.bpInfo({ brand_logo, brand_name, brand_description, product_info, is_mobile })}
      ${guide ? ProductDetailTabsTmplS.guide({ guide }) : ''}
      ${ProductDetailTabsTmplS.size({
        size_table,
        size_info_url,
        id,
        cate_list_id,
        cate_item_id,
        lang: T.lang,
        is_mobile,
      })}
      ${size_compare?.is_public
        ? ProductDetailTabsTmplS.sizeCompare({ size_compare_items: size_compare?.items }, is_mobile)
        : ''}
    </div>
  `,
};

export const MANUFACTURE_TAB = {
  name: 'MANUFACTURE_TAB',
  title: () => T('product_detail::Print Guide'),
  template: ({ print_guide, id, is_mobile }) => {
    return G.collabo_type === ''
      ? html`<div class="tab_wrapper">
          ${print_guide
            ? ProductDetailTabsTmplS.printGuide({ print_guide, is_mobile })
            : ProductDetailTabsTmplS.defaultPrintGuide({ id, is_mobile })}
          ${T.lang == 'kr'
            ? html`
                <div class="toggle_cont tg_delivery" is_open="false">
                  <div class="tg_head">
                    ${makeTgHead(T('product_detail::배송안내'))}
                    <span class="btn"></span>
                  </div>
                  <div class="tg_body">${makeProductDetailDeliveryAreaKrHtml()}</div>
                </div>
                <div class="toggle_cont tg_guide" is_open="false">
                  <div class="tg_head">
                    <span class="tit">품질보증/청약철회 안내</span>
                    <span class="btn"></span>
                  </div>
                  <div class="tg_body">${makeProductDetailGuidAreaKrHtml()}</div>
                </div>
              `
            : ''}
          ${T.lang == 'kr'
            ? html`
                <div class="bp_info_pop_buttons">
                  <span class="print">인쇄 관련 사항</span><span class="faq">자주 묻는 질문</span
                  ><span class="delivery">배송안내</span><span class="guide">품질보증/청약철회 안내</span>
                </div>
              `
            : ''}
        </div>`
      : print_guide
        ? html`<div class="tab_wrapper">
            ${ProductDetailTabsTmplS.printGuide({ print_guide, is_mobile })}
          </div>`
        : ``;
  },
};

const makeRelationBody = ({ design_collection_content, is_mobile }) => {
  if (!design_collection_content) return '';

  const [head_dcci, body_dcci] = design_collection_content;
  const items = go(
    body_dcci._.design_collection_content_items,
    map((idc) => idc._.product_color._.base_product),
    OMPProductListS.setBpsBrand,
    map((bp) => {
      const is_discount = parseFloat(bp.original_price) > parseFloat(bp.price);

      let discount_ranges = {
        price_ranges: [
          {
            start: 1,
            price_text: PriceS.pricify(PriceS.add(bp.price, bp.print_price)),
          },
        ],
        is_one: true,
      };

      if (bp._?.bp_discount_set?._?.bp_discount_ranges?.length) {
        discount_ranges = getPriceRanges(bp);
      }

      return {
        ...bp,
        model_thumb_url: UtilImageS.getResizedUrl({
          url: bp.model_thumb_url,
          width: 800,
          format: 'webp',
          quality: 100,
        }),
        is_discount,
        name: bp.name.replace(bp._.brand.name, '').trim(),
        minimum_price_text: TT('product::list::list_12_1', {
          price: PriceS.pricify(PriceS.add(bp.price, bp.print_price)),
        }),
        original_price_text: TT('product::list::list_13_1', {
          price: PriceS.pricify(PriceS.add(bp.original_price, bp.print_price)),
        }),
        badges: [],
        ...discount_ranges,
      };
    }),
  );
  return html`
    <div class="product_detail_relation_body">
      <h2 class="product_detail_relation_body-head">${head_dcci.title}</h2>

      ${is_mobile
        ? OMPCoreAtomTmplS.swiper({
            customClass: 'story-relation-seller',
            navigationClass: 'story-relation-seller-nav',
            arrow: !is_mobile,
            children: html`${OMPCoreAtomTmplS.swiperItems({
              items,
              renderer: OMPCoreCellTmplS.productMo,
            })}`,
          })
        : html` <ul class="story-relation-seller">
            ${strMap(OMPCoreCellTmplS.product, items)}
          </ul>`}
    </div>
  `;
};

const makeBannerBody = (is_mobile, alt, product_type, banner_type = 'header') => {
  if (_en !== '' || !product_type) return '';
  if (is_mobile && !DC_BANNER_EVENT.doing && banner_type === 'footer') return '';

  const _mobile = is_mobile ? '_mobile' : DC_BANNER_EVENT.doing ? '_sub' : '';
  const event_banner = `  <a class="product_detail_banner_item" href="${DC_BANNER_EVENT.url}">
                                    <img src="${DC_BANNER_EVENT['thumbnail' + _mobile]}" alt="${alt}"/>
                                 </a>`;
  const product_banner = `<div class="product_detail_banner_item">
                                    <img src="${DC_BANNER_PRODUCT[product_type + _mobile] || ''}" alt="${alt}"/>
                                 </div>`;

  const banners = is_mobile
    ? DC_BANNER_EVENT.doing && banner_type === 'header'
      ? event_banner
      : product_banner
    : (DC_BANNER_EVENT.doing ? event_banner : '') + product_banner;

  return pug`
  .product_detail_banner_body[type="banner"]
    .product_detail_banner_group
      ${banners}
  `;
};
